import './main.css'
import '../App.css'
import { useCallback, useEffect, useState, useRef } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import MessageModal from './messageModal';
import { Copy, UserPlus } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { changeNum, changeUnits } from './common/function';

import { changeAlramModal, changeGold, checkDuplicateLogins } from '../store';
import { useTranslation } from "react-i18next";
import { motion } from 'framer-motion';

import useWindowSize from '../hook/useWindowSize'

function RandomBox() {
    const { t } = useTranslation();
    let JWT = useSelector((state) => state.JWT.value);
    let myData = useSelector((state) => state.myData);
    let gold = useSelector((state) => state.gold.value);
    let dispatch = useDispatch();

    const { Rwidth, Rheight } = useWindowSize();

    const [message, setMessage] = useState("");
    const [randomBox, setRandomBox] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [completeModal, setCompleteModal] = useState(false);
    const [completeAmt, setCompleteAmt] = useState(0);

    // 영상 재생 여부(state)
    const [isPlayingVideo, setIsPlayingVideo] = useState(false);
    const [windowHeight, setWindowHeight] = useState(true);

    // 타이머 ID를 저장할 ref
    const videoTimeoutRef = useRef(null);

    useEffect(() => {
        RandomBoxData();
    }, []);

    useEffect(() => {
        if (Rheight < 660) setWindowHeight(false)
        else setWindowHeight(true)
    }, [Rheight])

    const RandomBoxData = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_API + '/api/randombox', {
                headers: { Authorization: `Bearer ${JWT}` }
            });
            let tmp = response.data;
            if (tmp?.code === 1000) {
                setRandomBox(tmp?.data?.randombox ?? []);
            }
        } catch (error) {
            if (error?.response?.status === 999) {
                dispatch(checkDuplicateLogins(true));
            } else {
                console.log(error);
            }
        }
    };

    // 아이템 선택 함수
    const handleSelectItem = (item) => {
        // gold가 buy_amount보다 적으면 선택 불가
        if (gold < item.buy_amount) return;

        // 이미 선택된 아이템이면 해제
        const isDeselected = selectedItem?.id === item.id;
        setSelectedItem(isDeselected ? null : item);
    };

    // 랜덤박스 열기
    const SubmitRandomBox = async () => {
        if (!selectedItem) return;

        try {
            const response = await axios.post(
                process.env.REACT_APP_API + '/api/randombox',
                { boxId: selectedItem.id },
                { headers: { Authorization: `Bearer ${JWT}` } }
            );

            let tmp = response.data;
            if (tmp?.code === 1000) {
                // 먼저 골드를 차감
                dispatch(changeGold(gold - selectedItem.buy_amount));
                // 서버에서 받은 개봉 결과량
                setCompleteAmt(tmp?.data?.randombox?.amount ?? 0);

                // --- 영상 재생 로직 ---
                setIsPlayingVideo(true); // 영상 보여주기 시작

                // 기존 타이머 있으면 클리어 (중복 방지)
                if (videoTimeoutRef.current) {
                    clearTimeout(videoTimeoutRef.current);
                }

                // 4.2초 후 자동 종료
                videoTimeoutRef.current = setTimeout(() => {
                    setIsPlayingVideo(false);
                    setCompleteModal(true);
                    videoTimeoutRef.current = null; // 타이머 초기화
                }, 4200);

            }
            else if (tmp?.code === -1000) {
                setMessage({ "code": 1, "msg": `${t('message_8')}` });
                dispatch(changeAlramModal());
            }
            else {
                setMessage({ "code": 1, "msg": `${t('message_9')}` });
                dispatch(changeAlramModal());
            }
        } catch (error) {
            if (error?.response?.status === 999) {
                dispatch(checkDuplicateLogins(true));
            } else {
                console.log(error);
            }
        }
    };

    // 모달에서 Confirm 버튼 클릭 시
    const ClickComfirm = () => {
        setCompleteModal(false);
        dispatch(changeGold(gold + completeAmt));
        setSelectedItem(null);
    };

    const DisableRandomBox = () => {
        setMessage({ "code": 1, "msg": `${t('message_10')}` });
        dispatch(changeAlramModal());
    };

    // 영상 스킵: 타이머 취소 + 영상 중단 + 완료 화면으로
    const handleSkip = () => {
        if (videoTimeoutRef.current) {
            clearTimeout(videoTimeoutRef.current);
            videoTimeoutRef.current = null;
        }
        setIsPlayingVideo(false);
        setCompleteModal(true);
    };

    return (
        <>
            <MessageModal message={message} />
            <div
                className='main'
                style={{
                    paddingTop: windowHeight ? "105px" : "55px",
                    zIndex: isPlayingVideo ? "104" : completeModal ? "104" : "100"
                }}
            >
                {/* 영상 재생중이라면 영상만 표시 */}
                {isPlayingVideo && (
                    <div style={{ width: '100%', height: "100%", background: "#000", position: 'relative' }}>
                        <video
                            className="video"
                            autoPlay
                            muted
                            playsInline
                        >
                            <source src="/newImg/randombox_video.mp4" type="video/mp4" />
                        </video>
                        <div
                            style={{
                                position: "absolute",
                                padding: "10px",
                                bottom: "50px",
                                left: "50%",
                                transform: "translateX(-50%)",
                                color: "gray",
                                zIndex: "1001",
                                fontWeight: "bold",
                                cursor: "pointer"
                            }}
                            onClick={handleSkip}
                        >
                            {t('randombox_5')}
                        </div>
                    </div>
                )}

                {/* 영상이 재생중이 아닐 때 랜덤박스 UI */}
                {!isPlayingVideo && (
                    <div className='main-box' style={{ padding: "0" }}>
                        {completeModal ? (
                            <div className='main-box-randombox'>
                                <img src={`/newImg/complete.jpg`} className='randombox-bg' />

                                <div className='randombox-clear' style={{ zIndex: "10", position: "relative" }}>
                                    <img
                                        src='/newImg/randombox_text.png'
                                        style={{ width: "300px" }}
                                    />
                                    <div className='randombox-clear-1'>
                                        <img
                                            src='/newImg/honey.png'
                                            style={{ width: "52px" }}
                                        />
                                    </div>
                                    <div style={{ fontSize: "34px", fontWeight: "bold", color: "#FBC73C" }}>
                                        ${changeNum(completeAmt)}
                                    </div>
                                    <div className="random" style={{ width: "calc(100% - 80px)", bottom: "90px" }}>
                                        <div className="random-buttons">
                                            <button className="random-button" onClick={ClickComfirm}>
                                                <span>{t('randombox_3')}</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <>
                                <img
                                    src={`/newImg/center.png`}
                                    className='randombox-bg'
                                    style={{ height: windowHeight ? "" : "100%" }}
                                />
                                <div className='friend' style={{ zIndex: "10", position: "relative" }}>
                                    <div className='settings-header' style={{ marginTop: "15px" }}>
                                        {t('randombox_0')}
                                    </div>

                                    <div className="random">
                                        <div className="item-previews">
                                            {randomBox.map((item, i) => {
                                                const imgWidth = 38 + i * 8;
                                                const isDisabled = gold < item.buy_amount;
                                                const isSelected = selectedItem?.id === item.id;

                                                return (
                                                    <div
                                                        key={item.id}
                                                        onClick={() => handleSelectItem(item)}
                                                        className={`
                                                            random-item
                                                            ${isSelected ? "selected" : ""}
                                                            ${isDisabled ? "disabled" : ""}
                                                        `}
                                                    >
                                                        <div
                                                            style={{
                                                                height: "55px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center"
                                                            }}
                                                        >
                                                            <img
                                                                src={
                                                                    isDisabled
                                                                        ? '/newImg/honey_no.png'
                                                                        : !isSelected
                                                                            ? '/newImg/honey_disabled.png'
                                                                            : '/newImg/honey.png'
                                                                }
                                                                style={{ width: `${imgWidth}px` }}
                                                            />
                                                        </div>
                                                        <div style={{ lineHeight: "18px", marginTop: '5px' }}>
                                                            ${changeNum(item.buy_amount)}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                        <div className="random-buttons">
                                            {!selectedItem ? (
                                                <button
                                                    className="random-button disable"
                                                    onClick={() => DisableRandomBox()}
                                                >
                                                    <span>{t('randombox_4')}</span>
                                                </button>
                                            ) : (
                                                <motion.div
                                                    onClick={SubmitRandomBox}
                                                    animate={{ scale: [1, 1.05, 1] }}
                                                    style={{ width: "100%" }}
                                                    transition={{
                                                        duration: 1.5,
                                                        repeat: Infinity,
                                                        repeatType: "loop"
                                                    }}
                                                >
                                                    <button className="random-button">
                                                        <span>{t('randombox_4')}</span>
                                                    </button>
                                                </motion.div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                )}
            </div>
        </>
    );
}

export default RandomBox;
